import {createSlice} from '@reduxjs/toolkit';

const locationsSclice = createSlice({
    name: 'locations',
    initialState: {
        locations: [],
        locations_search: [],
        loading_search: false,
        location: {
            city_name: 'Нижний Новгород',
            city_id: 1321,
        },
        search_form: {
            type: '0',
            category: '0'
        }
    },
    reducers: {
        setLoading_search: (state, action) => {
            state.loading_search = action.payload
        },
        setLocations_search: (state, action) => {
            state.locations_search = action.payload
        },
        setLocations: (state, action) => {
            state.locations = action.payload
        },
        setLocation: (state, action) => {
            state.location = action.payload
        },
        setSearch_form: (state, action) => {
            state.search_form = action.payload
        },
    },
});

export const { 
    setLoading_search,
    setLocations,
    setLocations_search,
    setLocation,
    setSearch_form
} = locationsSclice.actions
export default locationsSclice.reducer;